export default "__VITE_ASSET__DjOGc__A__"